import { r as react, C as Context, x as invariantIntlContext } from './injectIntl-6b03af4d.js';

function useIntl() {
    var intl = react.exports.useContext(Context);
    invariantIntlContext(intl);
    return intl;
}

export { useIntl as u };

//# sourceMappingURL=useIntl-dfb28031.js.map